<div class="map-container shadow-sm rounded-lg border" [ngStyle]="{'height': mapHeight}">
  <div class="map-frame">
    <div id="map"></div>
  </div>
</div>